module.exports = __webpack_public_path__ + "static/media/Philadelphia_School_Exhibit.52fd89e4.md";